module.exports = __webpack_public_path__ + "img/keep.3d7f98e5.png";